/**
 * Check if the given url can be found
 * in one of the given parent's children
 *
 * @param parent
 * @param url
 * @returns {boolean}
 */
export const isUrlInChildren = (parent, url) => {

    if (!parent.children) {
        return false;
    }

    for (let i = 0; i < parent.children.length; i++) {
        if (parent.children[i].children) {
            if (isUrlInChildren(parent.children[i], url)) {
                return true;
            }
        }

        const uri = parent.children[i].uri;
        if (uri && (url === uri || (url.startsWith(uri) && url.length > uri.length && url[uri.length] === '/'))) {
            return true;
        }
    }
    return false;
};